@if (selectedLine$ | async; as selectedLine) {
  <app-blade-header [bladeIndex]="bladeIndex" class="blade-header">
    <div title>
      <p class="title">{{ 'Line' | translate }} {{ selectedLine.routeName }}</p>
      <p class="caption">{{ selectedLine.firstStopDestinationSign }}</p>
    </div>
  </app-blade-header>
  <div class="line-table">
    <div class="table-header">
      <span class="caption-bold" translate>Stops</span>
    </div>
    @if ({ value: (stopsPlaces$ | async)}; as stopPlaces) {
      <div class="table-body">
        @if (stopPlaces.value.length) {
          @for (stopPlace of stopPlaces.value; track trackByStopPlaces($index, stopPlace)) {
            <div class="row" (mousedown)="onStopPlaceMouseDown($event, stopPlace, selectedLine, stopPlaces.value)"
              (mouseenter)="onStopPlaceMouseEnter(stopPlace, selectedLine)">
              <input type="checkbox" [id]="stopPlace.placeId" [checked]="stopPlace.selected"
                (mousedown)="$event.preventDefault()" />
              <div class="caption">
                {{ stopPlace.placeDescription }} {{ stopPlace.platformCode }}
              </div>
            </div>
          }
        } @else {
          @for (stopPlace of selectedLine.stopPlaces; track trackByStopPlaces($index, stopPlace)) {
            <div class="row" (click)="onStopAreaClick(stopPlace, selectedLine)">
              <input type="checkbox" [id]="stopPlace.stopAreaId" [checked]="stopPlace.selected"
                (click)="$event.stopPropagation()" />
              <div class="caption">
                {{ stopPlace.stopAreaDescription }}
              </div>
              @if (stopPlace.effectedRoutesLoader) {
                <places-spinner>
                </places-spinner>
              }
            </div>
          }
        }
      </div>
    }
  </div>
}